import message from "@/utils/globalMessage";
import React, { useState } from 'react';
import { Button, Avatar, Typography } from "antd";
import ResponsiveModal from "@components/ResponsiveModal";
import { UserOutlined } from '@ant-design/icons';
import { api } from "@redux/api";
import Auth from '@/components/Auth';
import { useSelector } from 'react-redux';
import Select from "@components/ResponsiveSelect";

const { Option } = Select;
const { Text } = Typography;

// 封装一个通用的 AssignButton 组件
const AssignButton = ({ taskId, facilityId, onAssignSuccess }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [usersLoading, setUsersLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isAssigning, setIsAssigning] = useState(false);
    
    const loadUsers = async () => {
        try {
            setUsersLoading(true);
            const response = await api.filterAssignedUsers(facilityId);
            if (response && response.data && response.data.results) {
                setUsersList(response.data.results);
            }
        } catch (error) {
            console.error('Error loading users:', error);
            message.error('Failed to load users list');
        } finally {
            setUsersLoading(false);
        }
    };

    const showModal = () => {
        loadUsers();
        setModalVisible(true);
    };

    const handleCancel = () => {
        setModalVisible(false);
        setSelectedUserId(null);
    };

    const handleUserChange = (value) => {
        setSelectedUserId(value);
    };

    const handleAssign = async () => {
        if (!selectedUserId) {
            message.warning('Please select a user to assign the task');
            return;
        }

        try {
            setIsAssigning(true);
            await api.assignEUITask(taskId, selectedUserId);
            message.success('Task assigned successfully');
            setModalVisible(false);
            setSelectedUserId(null);

            // 调用成功回调
            if (onAssignSuccess && typeof onAssignSuccess === 'function') {
                onAssignSuccess();
            }
        } catch (error) {
            console.error('Error assigning task:', error);
            message.error('Failed to assign task');
        } finally {
            setIsAssigning(false);
        }
    };

    return (
        <>
            <Auth code="certify_request_menu" level={2}>
                <a onClick={showModal} style={{ cursor: 'pointer' }}>
                    Assign
                </a>
            </Auth>
            <ResponsiveModal
                title="Assign Task"
                open={modalVisible}
                onOk={handleAssign}
                onCancel={handleCancel}
                confirmLoading={isAssigning}
            >
                <div style={{ marginBottom: 16 }}>
                    <p>Select a user to assign the task:</p>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select a user"
                        optionFilterProp="children"
                        getPopupContainer={(triggerNode) => triggerNode.parentElement}
                        dropdownStyle={{ zIndex: 1600 }}
                        onChange={handleUserChange}
                        value={selectedUserId}
                        loading={usersLoading}
                        filterOption={(input, option) =>{
                            return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                        }
                    >
                        {usersList.map(user => (
                            <Option key={user.id} value={user.id} name={user.username}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Avatar
                                        size="small"
                                        src={user.image}
                                        icon={<UserOutlined />}
                                        style={{ marginRight: 8 }}
                                    />
                                    <span>{user.username}</span>
                                    <Text type="secondary" style={{ marginLeft: 8 }}>
                                        ({user.email})
                                    </Text>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </div>
            </ResponsiveModal>
        </>
    );
};

export default AssignButton;
